import moment from 'moment'
import numeral from 'numeral'

moment.locale('fr-FR')

export default {
  formatDate: function (value, format) {
    // return moment(value).add(moment().utcOffset(), 'minutes').format(format || 'DD-MM-YYYY')
    return moment(value).format(format || 'DD-MM-YYYY')
  },
  formatDateUTC: function (value, format) {
    return moment(value).format(format || 'DD-MM-YYYY')
  },
  fromNowDate: function (value) {
    return moment(value).fromNow()
  },
  formatNumber: function (value, format) {
    return numeral(value).format(format || '0')
  },
  thumbnail: function (value, story, forcereload) {
    let forcereload_param = ''
    if (forcereload) {
      forcereload_param = `?forcereload=${(new Date())}`
    }
    return `${process.env.VUE_APP_STATIC_BASE_URL}/stories/${story.created_at.substr(0,4)}/${value}-${story.slug}.jpg${forcereload_param}`
  },
  static_url: function (value) {
    return `${process.env.VUE_APP_STATIC_BASE_URL}/${value}`
  },
  api_url: function (value) {
    return `${process.env.VUE_APP_API_BASE_URL}/${value}`
  }
}
